import React from 'react';
import CheckboxInput from 'shared/components/CheckboxInput';
import Label from 'shared/components/Label';

const PlatedEdges = (props) => {
  const name = 'plated_edges';

  const {
    parameters,
    onChangeParameter,
    groupName,
    label,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.checked ? '1' : '0');

  const checked = parameters && parameters[name] === '1';

  return (
    <div>
      <CheckboxInput
        inputId={name}
        inputClassName="mr-2"
        name={name}
        groupName={groupName}
        checked={checked}
        onChange={onChange} />
      <Label htmlFor={name} label={label} />
    </div>
  );
};

PlatedEdges.defaultProps = {
  label: Spree.translations.parameters.plated_edges,
  tooltip: Spree.helpForParameters.plated_edges,
};

export default PlatedEdges;
